import { useSelector } from 'react-redux';
import Tooltip from 'common/components/tooltip';
import { selectFilterModel, selectIsQuickFilterApplied } from '../slice';
import { isIncludedInFilters } from './helpers/helpers';
import { StyledToggleButton, StyledToggleButtonMore, StyledToggleButtonGroup, StyledTicketNumber } from './style';

export const ToggleButtonsWrapper = ({ quickFilters, handleTypeFilterClick, SrTypeFilterCounters }) => {
  const filterModelSelector = useSelector(selectFilterModel);
  const isQuickFilterApplied = useSelector(selectIsQuickFilterApplied);
  const srTypeActiveFilterKeys = filterModelSelector?.find((filter) => filter?.field === 'srType')?.values;
  const isAllChipSelected = !isQuickFilterApplied;
  const calculateAllTypesAmount = (filter) => {
    const filteredSrTypes = Array.isArray(srTypeActiveFilterKeys)
      ? quickFilters.reduce(
          (result, curr) =>
            srTypeActiveFilterKeys.includes(curr.idForFilter) ||
            srTypeActiveFilterKeys.includes(Number(curr.idForFilter))
              ? [...result, curr.valueForFilter]
              : result,
          [],
        )
      : [];

    return isAllChipSelected && filteredSrTypes.length
      ? filteredSrTypes.reduce((prev, curr) => prev + SrTypeFilterCounters[curr.toUpperCase()], 0)
      : SrTypeFilterCounters[filter.value.toUpperCase()];
  };

  return (
    <StyledToggleButtonGroup exclusive aria-label="Quick Filters" value="Quick Filter">
      {quickFilters?.map((filter, index) => {
        const displayName = filter?.valueToDisplay || filter?.value?.charAt(0).toUpperCase() + filter?.value?.slice(1);
        const selected =
          isQuickFilterApplied &&
          isIncludedInFilters(displayName, filter.idForFilter, filterModelSelector) &&
          !(srTypeActiveFilterKeys?.length && srTypeActiveFilterKeys?.length === quickFilters?.length);
        const key = `${filter?.valueForFilter}_${index}`;
        if (index === 0) {
          return (
            <StyledToggleButton
              data-testid="toggle-button-first"
              value={filter}
              selected={isAllChipSelected}
              key={key}
              isFirstButton
              onClick={() => handleTypeFilterClick(filter)}
              aria-label={filter?.valueForFilter}
              sx={{
                borderTopLeftRadius: '40px',
                borderBottomLeftRadius: '40px',
              }}
            >
              <Tooltip id={filter?.value} isTruncatedText title={displayName} text={displayName} />
              <StyledTicketNumber isSelected={isAllChipSelected}>
                <span className="text">{calculateAllTypesAmount(filter)}</span>
              </StyledTicketNumber>
            </StyledToggleButton>
          );
        }
        if (index === quickFilters?.length - 1) {
          return (
            <StyledToggleButtonMore
              data-testid="toggle-button-last"
              value
              key={key}
              isSelected={selected}
              onClick={() => handleTypeFilterClick(filter)}
            >
              <Tooltip id={filter?.value} isTruncatedText title={displayName} text={displayName} />
              <StyledTicketNumber isSelected={selected}>
                <span className="text">{SrTypeFilterCounters[filter.value.toUpperCase()]}</span>
              </StyledTicketNumber>
            </StyledToggleButtonMore>
          );
        }
        return (
          <StyledToggleButton
            data-testid="toggle-button-middle"
            value={filter}
            key={key}
            aria-label={filter.valueForFilter}
            selected={selected}
            onClick={() => handleTypeFilterClick(filter)}
          >
            <Tooltip id={filter?.value} isTruncatedText title={displayName} text={displayName} />
            <StyledTicketNumber isSelected={selected}>
              <span className="text">{SrTypeFilterCounters[filter.value.toUpperCase()]}</span>
            </StyledTicketNumber>
          </StyledToggleButton>
        );
      })}
    </StyledToggleButtonGroup>
  );
};
